"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackRequest = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// custom_dimensions in the message payload will be in a different format,
// this simplifies the process to store them in a table like storage.
// Payload is broker message payload, unlike TrackRequest,
// it will only contain one message.
// TrackRequest allows batched and delayed, as well as realtime events to be sent to the server.
var TrackRequest = function TrackRequest(tb, d) // payload data
{
  _classCallCheck(this, TrackRequest);

  this.tb = tb;
  this.d = d;
};

exports.TrackRequest = TrackRequest;